module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/088-uruguay-2559091455ccb5c62c1939fafa79b39a.svg";